module.exports = __webpack_public_path__ + "static/media/icon-data-cleansing.1e1400b7.svg";